import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as loginConfirmReducer from '../reducers/login-confirm.reducer';
import { loginConfirmFeatureKey } from '../reducers/login-confirm.reducer';

import * as fromAuthReducer from '../auth.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, fromAuthReducer.AuthState>(fromAuthReducer.authFeatureKey);
//#endregion

//#region CHECK REGISTRASTION SUB STATE
export const getLoginConfirmState = createSelector(getAuthState, state => state[loginConfirmFeatureKey]);

export const getLoginConfirmIsLoading = createSelector(getLoginConfirmState, loginConfirmReducer.getIsLoginConfirmLoading);

//#region CHECK REGISTRASTION
export const getLoginConfirmRequest = createSelector(getLoginConfirmState, loginConfirmReducer.getLoginConfirmRequest);
export const getLoginConfirmSuccess = createSelector(getLoginConfirmState, loginConfirmReducer.getLoginConfirmSuccess);
export const getLoginConfirmFailure = createSelector(getLoginConfirmState, loginConfirmReducer.getLoginConfirmFailure);
//#endregion
